import { render, staticRenderFns } from "./TelemetryEventBaseOverlay.vue?vue&type=template&id=58c8b053&"
import script from "./TelemetryEventBaseOverlay.vue?vue&type=script&lang=js&"
export * from "./TelemetryEventBaseOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports